import { AGENT_ACTIONS, isAgentActionKey, resolveNavigateEffect } from '@accio3d/shared/agent';
import type { AgentActionKey, AgentEffect } from '@accio3d/shared/agent';

import type { AgentSuggestion } from '../../api/agent';

/* Reads an action's effect as the general AgentEffect union  */
function effectFor(key: AgentActionKey): AgentEffect {
  return AGENT_ACTIONS[key].effect;
}

/* The in-app path a suggestion leads to, or null when it cannot be built. */
export function resolveSuggestionRoute(suggestion: AgentSuggestion): string | null {
  if (!isAgentActionKey(suggestion.key)) return null;

  const effect = effectFor(suggestion.key);
  if (effect.kind !== 'navigate') return null;

  return resolveNavigateEffect(effect, suggestion.params ?? {});
}
